{
  "version": 1,
  "asset_id": "00072369-0a53-4c7c-af36-e6867c312a17",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/00072369-0a53-4c7c-af36-e6867c312a17/cargo-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/00072369-0a53-4c7c-af36-e6867c312a17/cargo-card.webp",
  "original_filename": "cargo-card.webp",
  "size": 12502,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:49Z"
}
